import script from "./ValidateSkillsMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./ValidateSkillsMobile.vue?vue&type=script&setup=true&lang=js"

import "./ValidateSkillsMobile.vue?vue&type=style&index=0&id=860f94c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-860f94c6"]])

export default __exports__